import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LiveTvIcon(props: IconProps) {
    return <Icon {...props} iconKey={"live_tv"}/>
}
